import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { showAnimation } from 'src/animations';
import { IssueTypes } from 'src/app/lib/shared/globals';
import { Issue } from '../../../classes';
import { ISSUE_PROVIDER_SERVICE, ISSUE_TYPE_PROVIDER_SERVICE } from '../../../interfaces';
import { CreateIssueService } from '../../../services/create-issue-service';
import { IssueService } from '../../../services/issue.service';

@Component({
  selector: 'app-create-issue-dialog',
  templateUrl: './create-issue-dialog.component.html',
  styleUrls: ['./create-issue-dialog.component.css'],
  providers: [
    { provide: 'createIssueType', useValue: IssueTypes.Issue },
    { provide: ISSUE_PROVIDER_SERVICE, useClass: CreateIssueService },
    { provide: ISSUE_TYPE_PROVIDER_SERVICE, useExisting: ISSUE_PROVIDER_SERVICE }
  ],
  animations: [ showAnimation ]
})
export class CreateIssueDialogComponent implements OnInit {

  formGroup: FormGroup;

  private _processing: BehaviorSubject<boolean> = new BehaviorSubject(false);
  processing$ = this._processing.asObservable();

  constructor(
    @Inject(MAT_DIALOG_DATA) private _data: CreateIssueDialogComponentInputData,
    private _issueService: IssueService,
    private _formBuilder: FormBuilder,
    private _ref: MatDialogRef<CreateIssueDialogComponent>,
    private _router: Router,
    private _snackBar: MatSnackBar
  ) {
    this.formGroup = this._formBuilder.group({
      issue: this._formBuilder.group(new Issue())
    });
  }

  close = () => this._ref.close();

  ngOnInit(): void {
    if (this._data.issue) this.formGroup.controls['issue'].patchValue(this._data.issue);
  }

  saveIssue() {
    this._processing.next(true);
    this._issueService.createIssue((this.formGroup.controls['issue'] as FormGroup).getRawValue(), null)
      .pipe(switchMap((issue: Issue) => typeof this._data.afterStoring === 'function'? this._data.afterStoring(issue).pipe(map(_ => issue)): of(issue)))
      .subscribe({
        next: (issue: Issue) => {
          this._router.navigate(['/issue-details', issue.issueid]);
          this._ref.close(issue);
          this._processing.next(false);
        },
        error: (error: HttpErrorResponse) => this._snackBar.open(`Der Vorgang konnte nicht erzeugt werden (${error.status}).`)
      });
  }

}

export class CreateIssueDialogComponentInputData {
  issue: Issue;
  afterStoring?: (issue: Issue) => Observable<Object>;
}
